//const BASE_URL = "http://localhost:13340";
const BASE_URL = "https://db.ktdafoundation.or.ke"; // production

/**
 * Core fetch wrapper — handles JSON serialisation, error
 * normalisation, and non-2xx HTTP responses uniformly.
 *
 * @param {string} path       e.g. "/api/applications"
 * @param {RequestInit} opts  standard fetch options
 * @returns {Promise<any>}    parsed JSON body
 * @throws {{ message: string, status: number, body: any }}
 */
async function request(path, opts = {}) {
  const url = `${BASE_URL}${path}`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...opts.headers,
    },
    ...opts,
  };

  let response;
  try {
    response = await fetch(url, config);
  } catch (networkError) {
    // fetch() itself threw — server unreachable / CORS preflight failed
    throw {
      message:
        "Cannot reach the server. Please check your connection and try again.",
      status: 0,
      body: null,
    };
  }

  // Try to parse JSON regardless of status so we can surface API error messages
  let body = null;
  const contentType = response.headers.get("Content-Type") || "";
  if (contentType.includes("application/json")) {
    try {
      body = await response.json();
    } catch {
      body = null;
    }
  }

  if (!response.ok) {
    throw {
      message:
        body?.error ||
        body?.message ||
        `Request failed with status ${response.status}.`,
      status: response.status,
      body,
    };
  }

  return body;
}

// ─── Bursary Application endpoints ───────────────────────────────────────────

const bursaryApi = {
  /**
   * POST /api/applications
   * Maps the frontend form fields to the shape the Go controller expects.
   */
  create(fields) {
    // Resolve the county name from the code so the API gets both values
    const payload = {
      student_name: fields.studentName.trim(),
      reg_no: fields.regNo.trim(),
      school_level: fields.schoolLevel,
      county_code: fields.county,
      county_name: fields.countyName || "",
    };
    return request("/api/applications", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  /** GET /api/applications?page=n */
  list(page = 1) {
    return request(`/api/applications?page=${page}`);
  },

  /** GET /api/applications/:id */
  get(id) {
    return request(`/api/applications/${id}`);
  },

  /** PUT /api/applications/:id */
  update(id, fields) {
    const payload = {
      student_name: fields.studentName?.trim(),
      reg_no: fields.regNo?.trim(),
      school_level: fields.schoolLevel,
      county_code: fields.county,
      county_name: fields.countyName || "",
    };
    return request(`/api/applications/${id}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },

  /** PATCH /api/applications/:id/status */
  updateStatus(id, status) {
    return request(`/api/applications/${id}/status`, {
      method: "PATCH",
      body: JSON.stringify({ status }),
    });
  },

  /** DELETE /api/applications/:id */
  remove(id) {
    return request(`/api/applications/${id}`, { method: "DELETE" });
  },
};

export default bursaryApi;
